import { assert } from '../../babylon/utility/Assert.js';
/**
 * Debug Overlay.
 * - Creates an overlay canvas above a render canvas.
 * - Contains methods to draw on the canvas.
 */
export class Overlay {
    constructor(_debug_layer) {
        this._debug_layer = _debug_layer;
        this._overlay = document.createElement('canvas');
        this._overlay.style.position = 'absolute';
        this._overlay.style.left = '0';
        this._overlay.style.top = '0';
        this._overlay.style.pointerEvents = 'none';
        this._overlay.addEventListener('contextmenu', event => event.preventDefault());
        this._container = this._debug_layer.get_container();
        const context = this._overlay.getContext('2d');
        assert(context, 'Overlay canvas should have RenderingContext2D');
        this._context = context;
    }
    show() {
        if (!this._overlay.parentElement) {
            this._container.appendChild(this._overlay);
        }
        this.update();
    }
    hide() {
        if (this._overlay.parentElement) {
            this._container.removeChild(this._overlay);
        }
        this.clear_overlay();
    }
    dispose() {
        this.hide();
    }
    update() {
        this.clear_overlay();
    }
    draw_circle(x, y, radius, color, line_width) {
        this._context.beginPath();
        this._context.arc(x, y, radius, 0, Math.PI * 2, false);
        this._context.strokeStyle = color;
        this._context.lineWidth = line_width;
        this._context.stroke();
        this._context.closePath();
    }
    draw_rectangle(x, y, width, height, color, line_width) {
        this._context.beginPath();
        this._context.rect(x - width / 2, y - height / 2, width, height);
        this._context.strokeStyle = color;
        this._context.lineWidth = line_width;
        this._context.stroke();
        this._context.closePath();
    }
    draw_line(x1, y1, x2, y2, color, line_width) {
        this._context.strokeStyle = color;
        this._context.lineWidth = line_width;
        this._context.beginPath();
        this._context.moveTo(x1, y1);
        this._context.lineTo(x2, y2);
        this._context.stroke();
        this._context.closePath();
    }
    draw_infinite_line(x, y, angle, color, line_width) {
        const canvas_width = this._context.canvas.width;
        const canvas_height = this._context.canvas.height;
        // Calculate the end points of the line
        const x1 = x - canvas_width * Math.cos(angle);
        const y1 = y - canvas_height * Math.sin(angle);
        const x2 = x + canvas_width * Math.cos(angle);
        const y2 = y + canvas_height * Math.sin(angle);
        this._context.strokeStyle = color;
        this._context.lineWidth = line_width;
        this._context.beginPath();
        this._context.moveTo(x1, y1);
        this._context.lineTo(x2, y2);
        this._context.stroke();
        this._context.closePath();
    }
    clear_overlay() {
        this._context.clearRect(0, 0, this._overlay.width, this._overlay.height);
    }
    resize_overlay(canvas) {
        this._overlay.width = canvas.width;
        this._overlay.height = canvas.height;
    }
}
//# sourceMappingURL=Overlay.js.map